export default function checkImageName(image) {
	if (image?.imageType === 'raw') return image?.image_name;
	if (image?.imageType === 'detected') return image?.detected_image_name;

	return image?.detected_image_name;
}
